<script lang="ts">
  import type { Range } from '../model/filter';

  let { text, ranges = [] }: { text: string; ranges?: readonly Range[] } = $props();

  const parts = $derived.by(() => {
    const out: { text: string; mark: boolean }[] = [];
    let at = 0;
    for (const [start, end] of ranges) {
      if (start > at) out.push({ text: text.slice(at, start), mark: false });
      out.push({ text: text.slice(start, end), mark: true });
      at = end;
    }
    if (at < text.length) out.push({ text: text.slice(at), mark: false });
    return out;
  });
</script>

{#each parts as part, i (i)}{#if part.mark}<mark class="rounded-sm bg-accent-soft text-ink"
      >{part.text}</mark
    >{:else}{part.text}{/if}{/each}
